module.exports = __webpack_public_path__ + "static/img/wlx-baic-bg-img.6d535441.png";